import React from 'react';

import { CountryCodeEnum } from '../../../common/types';

import MevueloUyFooter from './MevueloUyFooter';
import MevueloPyFooter from './MevueloPyFooter';
import MevueloBoFooter from './MevueloBoFooter';
import MevueloCoFooter from './MevueloCoFooter';
import TiendaNaranjaPyFooter from './TiendanaranjaPyFooter';
import ExternalFooter from './ExternalFooter';

interface Props {
	country: string;
	isMultiDestination?: boolean;
	isExternal?: boolean;
}

export default function Footer({ country, isExternal }: Props): JSX.Element {
	if (isExternal) {
		return <ExternalFooter />;
	}

	switch (country) {
		case CountryCodeEnum.URUGUAY:
			return <MevueloUyFooter />;
		case CountryCodeEnum.PARAGUAY:
			return <MevueloPyFooter />;
		case CountryCodeEnum.BOLIVIA:
			return <MevueloBoFooter />;
		case CountryCodeEnum.COLOMBIA:
			return <MevueloCoFooter />;
		case CountryCodeEnum.TN_ITAU_PY:
			return <TiendaNaranjaPyFooter />;
		default:
			return <MevueloUyFooter />;
	}
}
